import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Check } from 'lucide-react';

function EmailSignup() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const formData = new FormData(e.target);
      
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString()
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      setSubmitted(true);
      setEmail('');
    } catch (err) {
      setError('Failed to submit. Please try again later.');
      console.error('Email submission error:', err);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="bg-sky-50 py-20 border-t border-sky-200">
      <div className="container mx-auto px-4 max-w-xl text-center">
        <div className="dashboard-card">
          <h2 className="text-3xl font-bold mb-6 glow-text">Stay Updated</h2>
          <p className="mb-8 text-slate-600">
            Sign up to receive updates about Family Dashboard availability and new features.
          </p>
          
          {submitted ? (
            <div className="bg-green-50 p-6 rounded-lg border border-green-200">
              <Check size={48} className="mx-auto text-green-500 mb-4" />
              <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--ryken-accent)' }}>Thank You!</h3>
              <p className="text-slate-600">We'll keep you updated on Family Dashboard news and release information.</p>
            </div>
          ) : (
            <>
              <form 
                onSubmit={handleSubmit} 
                className="flex flex-col sm:flex-row gap-2"
                name="email-signup"
                method="POST"
                netlify
                netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" value="email-signup" />
                <input type="hidden" name="bot-field" style={{ display: 'none' }} />
                <div className="relative flex-grow">
                  <Mail size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                    className="flex-grow pl-10 px-4 py-3 rounded-l-lg bg-white border border-sky-300 text-slate-800 w-full focus:outline-none focus:ring-2 focus:ring-sky-500"
                    disabled={loading}
                  />
                </div>
                <button
                  type="submit"
                  className={`text-white font-bold py-3 px-6 rounded-r-lg whitespace-nowrap transition-all duration-200 ${
                    loading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'
                  }`}
                  style={{ backgroundColor: 'var(--ryken-secondary)' }}
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'I\'m Interested!'}
                </button>
              </form>
              
              {error && (
                <div className="mt-4 text-red-600">
                  {error}
                </div>
              )}
            </>
          )}
          
          <p className="mt-4 text-sm text-blue-300">
            We respect your privacy. Read our <Link to="/privacy" className="underline hover:text-white">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default EmailSignup;